module.exports = __webpack_public_path__ + "img/jc.a28ced65.png";